import fetchPost from '@/api/http.js'

import fetchPostFormData from '@/api/http.js'
import axios from 'axios'

let baseURL = process.env.NODE_ENV === 'production' ? "/" : "/api";
const instance = axios.create({
    baseURL: baseURL,
    timeout: 5 * 60 * 1000,
    headers: { 'Content-Type': 'multipart/form-data' }
});

export default {
  actions: {
    // 拉取提送货单列表信息
    manifestGetTableDataApi({ }, data) {
      return fetchPost('/saas/deliveryAccess/queryList', data)
    },
    // 货主名称输入远程接口
    manifestNameSearchApi({ }, data) {
      return fetchPost('/saas/deliveryAccess/queryCustomerName', data)
    },
    // 导出
    manifestExportApi({ }, data) {
      return fetchPost('/saas/deliveryAccess/export', data)
    },
    // 详情
    manifestDetailApi({ }, data) {
      return fetchPost('/saas/deliveryAccess/queryDeliveryDetail', data)
    },
    // 审核
    manifestDetaiReviewlApi({ }, data) {
      return fetchPost('/saas/deliveryAccess/checkActualDelivery', data)
    }
  }
}